import { Component } from 'preact';
import PropTypes from "prop-types";
import withConfiguration from "../shared/hoc/withConfiguration";
import { GreenSocket } from "@green24/npm-javascript-utils";
import { ValueUpdateListeners } from "@green24/npm-preact-utils";

class SocketListener extends Component {
	constructor() {
		super();

		this._valueUpdateListener = new ValueUpdateListeners(this);
	}

	componentDidMount() {
		this._valueUpdateListener.getValueWithUpdateListener("props.configuration.apiURL", () => {
			this._initializeSocket();
		});
	}

	componentDidUpdate(previousProps, previousState, snapshot) {
		this._valueUpdateListener.componentDidUpdate(previousProps, previousState);
	}

	render({className, style}, {}) {
		return null;
	}

	_initializeSocket() {
		if(window.greenSocket) {
			window.greenSocket.disconnect("Api change");
		}

		const {configuration} = this.props;

		if(!configuration?.apiURL) return;

		// noinspection HttpUrlsUsage
		let wsUrl = `${configuration.apiURL}`.replace("https://", "wss://").replace("http://", "ws://");

		let socket = window.greenSocket = new GreenSocket(`${wsUrl}/ws-connect`);
		socket.connect();

		socket.onDestination("/update", () => {
			window.location.reload(true);
		});

		socket.subscribeTopic("/update");
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			configuration: PropTypes.object,
		}
	}
}

export default withConfiguration(SocketListener);
